import * as React from "react";
import { IPetsyHelperTextsProps } from "./PetsyHelperTexts.types";
import { Icon, IconSize, IconColorStyle } from "@adaptis/flow-components";
import _ from "../../imports/lodash-imports";
import "./PetsyHelperTexts.scss";
import { PopupTip } from "@adaptis/flow-components";
import { tips } from "../PopupTips/tips";

export default function PetsyTableGreenBoxes(props: IPetsyHelperTextsProps) {
  const tip = props.tooltip ? _.get(tips, props.tooltip.tipName) : undefined;
  // console.log("[PPP-219] tip", props.tooltip, tip);

  return (
    <div
      className={`flc_petsy-feature-label-group petsy-helper-texts ${
        props.isHaveLineBottom ? "line-bottom" : ""
      }  ${props.className ? props.className : ""}`}
    >
      <div className="helper-item">
        <div className="flc_feature-label">
          <Icon
            className="me-2"
            src={"/images/icons/check-green-bg.svg"}
            colorStyle={IconColorStyle.Success}
            size={IconSize.ExtraSmall}
          />
        </div>
        <div className="helper-content">
          <span className="">{props.content}</span>
          {tip && <PopupTip className="ms-3" tip={tip} label={props.tooltip?.label}></PopupTip>}
        </div>
      </div>
    </div>
  );
}
